module.exports = __webpack_public_path__ + "img/empty-box.243ceb73.svg";